import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function autocompleteValueValidator(): ValidatorFn {
  return (control: AbstractControl<string | Record<string, unknown>>): ValidationErrors | null => {
    const { value } = control;

    if (!value || typeof value !== 'string') return null;

    return {
      autocomplete: true,
    };
  };
}
